module.exports = __webpack_public_path__ + "img/zaken_yes.dd5d0cc2.png";